package app.properties

data class Document(
        var id: String? = null,
        var documentType: DocumentType? = null,
        var documentNumber: String = "",
        var docuemntGiveTime: String = "",
        var whoGiveDocument: String = ""
) {
    fun isValid() : Boolean {

        return (documentType != null &&
                documentNumber != "" &&
                docuemntGiveTime != "" &&
                whoGiveDocument != "")
    }
}